module.exports = __webpack_public_path__ + "img/SuperHotRollPoker_DG.8881abc8.jpg";